<template>
  <div class="auth-page">
    <!-- Header -->
    <header class="auth-header">
      <div class="container">
        <h1 class="app-title">
          {{ $t('common.app_name') }}
        </h1>
      </div>
    </header>

    <!-- Main Content -->
    <div class="auth-content">
      <div class="container">
        <router-view></router-view>
      </div>
    </div>

    <!-- Footer -->
    <Footer :with-sidebar="false" />

    <!-- Language Switcher FAB -->
    <LanguageSwitcher />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import Footer from './Footer.vue';
import LanguageSwitcher from '../../components/common/LanguageSwitcher.vue';
import { colors } from '../../../consts/colors';

const { t: $t } = useI18n();

</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: v-bind('colors.background');
}

.auth-header {
  background-color: v-bind('colors.white');
  padding: 1rem 0;
  border-bottom: 1px solid v-bind('colors.borderMedium');
}

.app-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: v-bind('colors.textPrimary');
  margin: 0;
}

.auth-content {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 3rem 0;
}

/* Make sure the container inside auth-content takes full width if needed,
   but let the child components control their own grid/layout */
.auth-content .container {
  width: 100%;
}
</style>
